import { useTranslation } from 'react-i18next'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'



import { Product, useProductsPreviewCardQuery } from '@shared/generated'

export default function ProductCarouselNew () {
  const { t: tp } = useTranslation('product')
  const { shopId } = useAddressStore()
  const { data, loading } = useProductsPreviewCardQuery({
    variables: {
      shopId: shopId,
      sort: {
        fieldName: 'new',
      },
    },
  })

  return (
    <>
      {data && data.products?.edges && data.products?.edges?.length > 0 && (
        <ProductCarousel
          link="/catalog"
          title={tp('new')}
          products={data.products?.edges as Product[]}
          loading={loading}
        />
      )}
    </>
  )
}